<!--begin::Modal - Edit client details-->
<div class="modal fade" id="kt_modal_edit_client" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary" id="kt_modal_edit_client_header">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Client' : 'Add Client' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-kt-clients-modal-action="close"
          (click)="closeModal()">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>
      <form id="kt_modal_edit_client_form" class="form" [formGroup]="clientForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="d-flex flex-column scroll-y p-3" id="kt_modal_edit_client_scroll" data-kt-scroll="true"
            data-kt-scroll-activate="true" data-kt-scroll-max-height="auto"
            data-kt-scroll-dependencies="#kt_modal_edit_client_header"
            data-kt-scroll-wrappers="#kt_modal_edit_client_scroll" data-kt-scroll-offset="300px">

            <!-- Avatar Section -->
            <div class="fv-row mb-7">
              <label class="d-block fw-semibold fs-6 mb-5">Avatar</label>
              <div class="image-input image-input-outline image-input-placeholder" data-kt-image-input="true">
                <div class="image-input-wrapper w-125px h-125px"
                  [style.background-image]="imagePreviewUrl ? 'url(' + imagePreviewUrl + ')' : 'url(assets/media/svg/files/blank-image.svg)'">
                </div>
                <label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                  data-kt-image-input-action="change" data-bs-toggle="tooltip" title="Change avatar">
                  <i class="ki-duotone ki-pencil fs-7">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  <input type="file" name="avatar" accept=".png, .jpg, .jpeg" (change)="onImageSelected($event)" />
                  <input type="hidden" name="avatar_remove" />
                </label>
                <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                  data-kt-image-input-action="cancel" data-bs-toggle="tooltip" title="Cancel avatar"
                  (click)="removeImage()">
                  <i class="ki-duotone ki-cross fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
                <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                  data-kt-image-input-action="remove" data-bs-toggle="tooltip" title="Remove avatar"
                  (click)="removeImage()">
                  <i class="ki-duotone ki-cross fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
              </div>
              <div class="form-text">Allowed file types: png, jpg, jpeg.</div>
            </div>

            <div class="row">
              <!-- Left Column -->
              <div class="col-md-6">
                <!-- Status -->
                <div class="fv-row mb-5">
                  <label class="form-label fs-7 fw-semibold mb-2">Status <span class="required"></span></label>
                  <div class="d-flex">
                    <div class="form-check form-check-custom form-check-solid me-5">
                      <input class="form-check-input" type="radio" formControlName="status" value="blocked"
                        id="status_inactive">
                      <label class="form-check-label" for="status_inactive">Blocked</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid">
                      <input class="form-check-input" type="radio" formControlName="status" value="permitted"
                        id="status_permitted">
                      <label class="form-check-label" for="status_permitted">Permitted</label>
                    </div>
                  </div>
                  <div class="text-danger small mt-1"
                    *ngIf="clientForm.get('status')?.invalid && clientForm.get('status')?.touched">
                    <div *ngIf="clientForm.get('status')?.errors?.['required']">Status is required</div>
                  </div>
                </div>

                <!-- Permissions Checkboxes -->
                <div class="fv-row mb-5">
                  <label class="form-label fs-7 fw-semibold mb-2">Permissions</label>
                  <div class="d-flex flex-column">
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="broker" id="broker">
                      <label class="form-check-label" for="broker">Broker</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="auction" id="auction">
                      <label class="form-check-label" for="auction">Auction</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="uss" id="uss">
                      <label class="form-check-label" for="uss">USS</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="uss_image" id="uss_image">
                      <label class="form-check-label" for="uss_image">USS Image</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="bids" id="bids">
                      <label class="form-check-label" for="bids">Bids</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="sales_stats" id="sales_stats">
                      <label class="form-check-label" for="sales_stats">Sales Stats</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="show_cif" id="show_cif">
                      <label class="form-check-label" for="show_cif">Show CIF</label>
                    </div>
                    <!-- <div class="form-check form-check-custom form-check-solid mb-2">
                                            <input class="form-check-input" type="checkbox" formControlName="salman_dockage" id="salman_dockage">
                                            <label class="form-check-label" for="salman_dockage">Salman Dockage</label>
                                        </div> -->
                    <div class="form-check form-check-custom form-check-solid mb-2">
                      <input class="form-check-input" type="checkbox" formControlName="show_resale_price"
                        id="show_resale_price">
                      <label class="form-check-label" for="show_resale_price">Show Result Price</label>
                    </div>
                  </div>
                </div>

                <!-- Bid Permission -->
                <div class="fv-row mb-5">
                  <label class="form-label fs-7 fw-semibold mb-2">Bid Permission</label>
                  <div class="d-flex">
                    <div class="form-check form-check-custom form-check-solid me-5">
                      <input class="form-check-input" type="radio" formControlName="bid_permission" value="yes"
                        id="bid_yes">
                      <label class="form-check-label" for="bid_yes">Yes</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid">
                      <input class="form-check-input" type="radio" formControlName="bid_permission" value="no"
                        id="bid_no">
                      <label class="form-check-label" for="bid_no">No</label>
                    </div>
                  </div>
                </div>

                <!-- Rating -->
                <div class="fv-row mb-5">
                  <label for="rating" class="form-label fs-7 fw-semibold mb-2">Rating</label>
                  <select class="form-select form-select-sm" formControlName="rating" id="rating">
                    <option value="">Select Rating</option>
                    <option value="gold">Gold</option>
                    <option value="silver">Silver</option>
                    <option value="platinum">Platinum</option>
                    <option value="free">Free</option>
                  </select>
                </div>

                <!-- Name -->
                <div class="fv-row mb-5">
                  <label for="name" class="form-label fs-7 fw-semibold mb-2">Name <span class="required"></span></label>
                  <div class="form-group row">
                    <div class="col-md-3">
                      <select class="form-select form-select-sm" formControlName="title"
                        [class.is-invalid]="clientForm.get('title')?.invalid && clientForm.get('title')?.touched">
                        <option value="Mr.">Mr.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Dr.">Dr.</option>
                      </select>
                      <div class="invalid-feedback"
                        *ngIf="clientForm.get('title')?.invalid && clientForm.get('title')?.touched">
                        <div *ngIf="clientForm.get('title')?.errors?.['required']">Title is required</div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <input type="text" formControlName="name" id="name" class="form-control form-control-sm"
                        placeholder="Full Name"
                        [class.is-invalid]="clientForm.get('name')?.invalid && clientForm.get('name')?.touched" />
                      <div class="invalid-feedback"
                        *ngIf="clientForm.get('name')?.invalid && clientForm.get('name')?.touched">
                        <div *ngIf="clientForm.get('name')?.errors?.['required']">Name is required</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Company -->
                <div class="fv-row mb-5">
                  <label for="company" class="form-label fs-7 fw-semibold mb-2">Company</label>
                  <input type="text" formControlName="company" id="company" class="form-control form-control-sm"
                    placeholder="Company Name" />
                </div>

                <!-- Country -->
                <div class="fv-row mb-5">
                  <label for="country" class="form-label fs-7 fw-semibold mb-2">Country</label>
                  <select class="form-select form-select-sm" formControlName="country" id="country"
                    (change)="onCountryChange($any($event.target).value)">
                    <option value="">Select Country</option>
                    <option *ngFor="let country of countryList" [value]="country.name">{{ country.name }}</option>
                  </select>
                </div>

                <!-- Port -->
                <div class="fv-row mb-5">
                  <label for="port" class="form-label fs-7 fw-semibold mb-2">Port</label>
                  <select class="form-select form-select-sm" formControlName="port" id="port">
                    <option value="">Select Port</option>
                    <option *ngFor="let port of portList" [value]="port.value">{{ port.label }}</option>
                  </select>
                </div>

                <!-- Address -->
                <div class="fv-row mb-5">
                  <label for="address" class="form-label fs-7 fw-semibold mb-2">Address <span
                      class="required"></span></label>
                  <textarea formControlName="address" id="address" class="form-control form-control-sm" rows="2"
                    placeholder="Address"
                    [class.is-invalid]="clientForm.get('address')?.invalid && clientForm.get('address')?.touched"></textarea>
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('address')?.invalid && clientForm.get('address')?.touched">
                    <div *ngIf="clientForm.get('address')?.errors?.['required']">Address is required</div>
                  </div>
                </div>

                <!-- State -->
                <div class="fv-row mb-5">
                  <label for="state" class="form-label fs-7 fw-semibold mb-2">State <span
                      class="required"></span></label>
                  <input type="text" formControlName="state" id="state" class="form-control form-control-sm"
                    placeholder="State"
                    [class.is-invalid]="clientForm.get('state')?.invalid && clientForm.get('state')?.touched" />
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('state')?.invalid && clientForm.get('state')?.touched">
                    <div *ngIf="clientForm.get('state')?.errors?.['required']">State is required</div>
                  </div>
                </div>

                <!-- Mobile -->
                <div class="fv-row mb-5">
                  <label for="mobile" class="form-label fs-7 fw-semibold mb-2">Mobile <span
                      class="required"></span></label>
                  <input type="text" formControlName="mobile" id="mobile" class="form-control form-control-sm"
                    placeholder="Mobile Number"
                    [class.is-invalid]="clientForm.get('mobile')?.invalid && clientForm.get('mobile')?.touched" />
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('mobile')?.invalid && clientForm.get('mobile')?.touched">
                    <div *ngIf="clientForm.get('mobile')?.errors?.['required']">Mobile is required</div>
                  </div>
                </div>
              </div>

              <!-- Right Column -->
              <div class="col-md-6">
                <!-- City -->
                <div class="fv-row mb-5">
                  <label for="city" class="form-label fs-7 fw-semibold mb-2">City</label>
                  <input type="text" formControlName="city" id="city" class="form-control form-control-sm"
                    placeholder="City" />
                </div>

                <!-- Telephone -->
                <div class="fv-row mb-5">
                  <label for="phone" class="form-label fs-7 fw-semibold mb-2">Telephone <span
                      class="required"></span></label>
                  <input type="text" formControlName="phone" id="phone" class="form-control form-control-sm"
                    placeholder="Telephone Number"
                    [class.is-invalid]="clientForm.get('phone')?.invalid && clientForm.get('phone')?.touched" />
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('phone')?.invalid && clientForm.get('phone')?.touched">
                    <div *ngIf="clientForm.get('phone')?.errors?.['required']">Telephone is required</div>
                  </div>
                </div>

                <!-- Skype ID -->
                <div class="fv-row mb-5">
                  <label for="skype_id" class="form-label fs-7 fw-semibold mb-2">Skype Id</label>
                  <input type="text" formControlName="skype_id" id="skype_id" class="form-control form-control-sm"
                    placeholder="Skype ID" />
                </div>

                <!-- Fax -->
                <div class="fv-row mb-5">
                  <label for="fax" class="form-label fs-7 fw-semibold mb-2">Fax</label>
                  <input type="text" formControlName="fax" id="fax" class="form-control form-control-sm"
                    placeholder="Fax Number" />
                </div>

                <!-- Email/Login ID -->
                <div class="fv-row mb-5">
                  <label for="email" class="form-label fs-7 fw-semibold mb-2">Email/Login ID <span
                      class="required"></span></label>
                  <input type="email" formControlName="email" id="email" class="form-control form-control-sm"
                    placeholder="Email Address"
                    [class.is-invalid]="clientForm.get('email')?.invalid && clientForm.get('email')?.touched" />
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('email')?.invalid && clientForm.get('email')?.touched">
                    <div *ngIf="clientForm.get('email')?.errors?.['required']">Email is required</div>
                    <div *ngIf="clientForm.get('email')?.errors?.['email']">Please enter a valid email</div>
                  </div>
                </div>

                <!-- Password -->
                <div class="fv-row mb-5">
                  <label for="password" class="form-label fs-7 fw-semibold mb-2">Password <span class="required"
                      *ngIf="!isEditMode"></span></label>
                  <input type="password" formControlName="password" id="password" class="form-control form-control-sm"
                    [placeholder]="isEditMode ? 'Leave blank to keep current password' : 'Enter password'"
                    [class.is-invalid]="clientForm.get('password')?.invalid && clientForm.get('password')?.touched" />
                  <div class="form-text" *ngIf="isEditMode">Leave blank to keep current password</div>
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('password')?.invalid && clientForm.get('password')?.touched">
                    <div *ngIf="clientForm.get('password')?.errors?.['required']">Password is required</div>
                  </div>
                </div>

                <!-- Currency Type -->
                <div class="fv-row mb-5">
                  <label for="currency_type" class="form-label fs-7 fw-semibold mb-2">Currency Type</label>
                  <select class="form-select form-select-sm" formControlName="currency_type" id="currency_type">
                    <option value="usd">USD</option>
                    <option value="jpy">JPY</option>
                  </select>
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('currency_type')?.invalid && clientForm.get('currency_type')?.touched">
                    <div *ngIf="clientForm.get('currency_type')?.errors?.['required']">Currency is required</div>
                  </div>
                </div>

                <!-- Opening Balance -->
                <div class="fv-row mb-5">
                  <label for="opening_balance" class="form-label fs-7 fw-semibold mb-2">Opening Balance</label>
                  <div class="input-group">
                    <span class="input-group-text">{{ clientForm.value.currency_type?.toUpperCase() || 'USD' }}</span>
                    <input type="number" formControlName="opening_balance" id="opening_balance"
                      class="form-control form-control-sm" placeholder="0.00" step="0.01" />
                  </div>
                </div>

                <!-- Opening Balance Type -->
                <div class="fv-row mb-5">
                  <label class="form-label fs-7 fw-semibold mb-2">Opening Balance Type</label>
                  <div class="d-flex">
                    <div class="form-check form-check-custom form-check-solid me-5">
                      <input class="form-check-input" type="radio" formControlName="opening_balance_type" value="debit"
                        id="balance_debit">
                      <label class="form-check-label" for="balance_debit">Debit</label>
                    </div>
                    <div class="form-check form-check-custom form-check-solid">
                      <input class="form-check-input" type="radio" formControlName="opening_balance_type" value="credit"
                        id="balance_credit">
                      <label class="form-check-label" for="balance_credit">Credit</label>
                    </div>
                  </div>
                </div>

                <!-- Sales Person -->
                <div class="fv-row mb-5">
                  <label for="sales_person_id" class="form-label fs-7 fw-semibold mb-2">Sales Person <span
                      class="required"></span></label>
                  <select class="form-select form-select-sm" formControlName="sales_person_id" id="sales_person_id"
                    [class.is-invalid]="clientForm.get('sales_person_id')?.invalid && clientForm.get('sales_person_id')?.touched">
                    <option value="">Select Sales Person</option>
                    <option *ngFor="let person of salesPersonList" [value]="person.value">{{ person.label }}</option>
                  </select>
                  <div class="invalid-feedback"
                    *ngIf="clientForm.get('sales_person_id')?.invalid && clientForm.get('sales_person_id')?.touched">
                    <div *ngIf="clientForm.get('sales_person_id')?.errors?.['required']">Sales Person is required</div>
                  </div>
                </div>

                <!-- Document Upload -->
                <div class="fv-row mb-5">
                  <label for="document" class="form-label fs-7 fw-semibold mb-2">Document</label>
                  <input type="file" class="form-control form-control-sm" id="document"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
                  <div class="form-text">Allowed file types: pdf, doc, docx, jpg, jpeg, png</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-sm" data-bs-dismiss="modal"
            (click)="closeModal()">Cancel</button>
          <button type="submit" class="btn btn-primary btn-sm" style="min-width: 120px; height: 38px;">
            <span *ngIf="!isLoading">{{ isEditMode ? 'Update Client' : 'Add Client' }}</span>
            <span class="indicator-progress" *ngIf="isLoading">Please wait...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
